module.exports = __webpack_public_path__ + "resources/img/logo_nhn_cloud_color.f2d82e81e8cf340c6a403321c859f49e.svg";